import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';
import { FC } from 'react';

const EnergyConsumptionTable: FC = () => {
  const { t } = useTranslationWithPrefix('views.process.quizQuestions.energyTable');

  // Kraków, Gdańsk and Wrocław keep their names in English (as in the quiz answers), only Warsaw differs
  const energyData = [
    {
      energyConsumption: '15,000',
      office: 'Kraków',
      renewableSources: '20%',
    },
    {
      energyConsumption: '18,000',
      office: 'Gdańsk',
      renewableSources: '5%',
    },
    {
      energyConsumption: '10,000',
      office: 'Wrocław',
      renewableSources: '10%',
    },
    {
      energyConsumption: '20,000',
      office: t('warsaw'),
      renewableSources: '50%',
    },
  ];

  return (
    <table className="table table-bordered-custom">
      <thead>
        <tr>
          <th>{t('office')}</th>
          <th>{t('energyConsumption')}</th>
          <th>{t('renewableSources')}</th>
        </tr>
      </thead>
      <tbody>
        {energyData.map(item => (
          <tr key={item.office}>
            <td>{item.office}</td>
            <td>{item.energyConsumption}</td>
            <td>{item.renewableSources}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default EnergyConsumptionTable;
